import request from '@/config/axios'

export interface AgentDashboardSummaryVO {
  normalCount?: number
  pendingApplyCount?: number
  level2Count?: number
  monthNewCount?: number
}

export interface AgentOperateLogVO {
  id?: number
  bizType?: string
  bizId?: number
  action?: string
  content?: string
  operatorId?: number
  operatorName?: string
  createTime?: string
}

export interface AgentProfileVO {
  id?: number
  agentNo?: string
  name?: string
  agentType?: number
  contactName?: string
  contactMobile?: string
  level?: number
  parentId?: number
  parentName?: string
  regionCode?: string
  regionName?: string
  regionExclusive?: boolean
  status?: number
  kycLicenseUrl?: string
  kycIdCardUrl?: string
  kycIdCardBackUrl?: string
  contractSigned?: boolean
  bankName?: string
  bankAccountNo?: string
  bankAccountName?: string
  rejectReason?: string
  applyTime?: string
  auditTime?: string
  remark?: string
  createTime?: string
}

export interface AgentProfileSimpleVO {
  id: number
  agentNo?: string
  name: string
  regionName?: string
}

export interface AgentApplyVO {
  id?: number
  applyNo?: string
  profileId?: number
  name?: string
  agentType?: number
  contactName?: string
  contactMobile?: string
  level?: number
  parentId?: number
  parentName?: string
  regionCode?: string
  regionName?: string
  regionExclusive?: boolean
  kycLicenseUrl?: string
  kycIdCardUrl?: string
  kycIdCardBackUrl?: string
  contractSigned?: boolean
  bankName?: string
  bankAccountNo?: string
  bankAccountName?: string
  clientSource?: string
  status?: number
  rejectReason?: string
  submitTime?: string
  auditTime?: string
}

export const getDashboardSummary = () =>
  request.get<AgentDashboardSummaryVO>({ url: '/agent/dashboard/summary' })

export const getDashboardRecentLogs = () =>
  request.get<AgentOperateLogVO[]>({ url: '/agent/dashboard/recent-logs' })

export const getProfilePage = (params: any) =>
  request.get<{ list: AgentProfileVO[]; total: number }>({ url: '/agent/profile/page', params })

export const getProfile = (id: number) =>
  request.get<AgentProfileVO>({ url: '/agent/profile/get', params: { id } })

export const updateProfile = (data: AgentProfileVO) =>
  request.put({ url: '/agent/profile/update', data })

export const updateProfileStatus = (data: { id: number; status: number }) =>
  request.put({ url: '/agent/profile/update-status', data })

export const getParentOptions = () =>
  request.get<AgentProfileSimpleVO[]>({ url: '/agent/profile/parent-options' })

export const getApplyPage = (params: any) =>
  request.get<{ list: AgentApplyVO[]; total: number }>({ url: '/agent/apply/page', params })

export const getApply = (id: number) =>
  request.get<AgentApplyVO>({ url: '/agent/apply/get', params: { id } })

export const createApply = (data: any) =>
  request.post({ url: '/agent/apply/create', data })

export const auditApply = (data: { id: number; approve: boolean; rejectReason?: string }) =>
  request.put({ url: '/agent/apply/audit', data })

export const getOperateLogPage = (params: any) =>
  request.get<{ list: AgentOperateLogVO[]; total: number }>({ url: '/agent/operate-log/page', params })
